/**
 * @generated SignedSource<<e9340f8228d467af9636bdf59b1c8aa7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QueueSidebarQuery$variables = Record<PropertyKey, never>;
export type QueueSidebarQuery$data = {
  readonly agentPoolsRest: {
    readonly " $fragmentSpreads": FragmentRefs<"QueueSidebarPoolsFragment">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"QueueSidebarPoolIdsFragment">;
};
export type QueueSidebarQuery = {
  response: QueueSidebarQuery$data;
  variables: QueueSidebarQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "QueueSidebarQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "QueueSidebarPoolIdsFragment"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AgentPools",
        "kind": "LinkedField",
        "name": "agentPoolsRest",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "QueueSidebarPoolsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "QueueSidebarQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AgentPools",
        "kind": "LinkedField",
        "name": "agentPoolsRest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AgentPoolRest",
            "kind": "LinkedField",
            "name": "agentPool",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "_id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3fcb5c1fa51be9d918c664a2276a11aa",
    "id": null,
    "metadata": {},
    "name": "QueueSidebarQuery",
    "operationKind": "query",
    "text": "query QueueSidebarQuery {\n  ...QueueSidebarPoolIdsFragment\n  agentPoolsRest {\n    ...QueueSidebarPoolsFragment\n  }\n}\n\nfragment QueueSidebarPoolIdsFragment on Query {\n  agentPoolsRest {\n    agentPool {\n      id\n      _id\n    }\n  }\n}\n\nfragment QueueSidebarPoolsFragment on AgentPools {\n  agentPool {\n    id\n    name\n    _id\n  }\n}\n"
  }
};

(node as any).hash = "bb1af71984a9c6b21121bec498ebe9cc";

export default node;
